import React, { useContext } from 'react';

// components
import BackToCourseOutlineButton from './actions/back-to-course-outline-button';
import DuplicateLecturePageButton from './actions/duplicate-lecture-page-button';
import AddNewLessonButton from './actions/add-new-lesson-button';
import AddToCollectionButton from './actions/add-to-collection-button';
import DeleteLessonButton from './actions/delete-lesson-button';
import ExitButton from './actions/exit-button';

type EditMenuRightPanelProps = {
  onExitClick: () => void;
};

export const EditMenuRightPanel = ({ onExitClick }: EditMenuRightPanelProps) => (
  <div className='d-flex align-items-center'>
    <BackToCourseOutlineButton />
    <DuplicateLecturePageButton />
    <AddNewLessonButton />
    <AddToCollectionButton />
    <DeleteLessonButton />
    <ExitButton onClick={onExitClick} />
  </div>
);

export default EditMenuRightPanel;
